import { Either, fold } from 'fp-ts/Either';
import { constNull, identity, pipe } from 'fp-ts/function';

export function toNullable<T>(either: Either<unknown, T>): T | null {
  return pipe(either, fold(constNull, identity));
}
